import { Link, LinkProps } from "react-router-dom";
import { useAppDispatch } from "../../effects/useAppDispatch";
import { errorActions } from "../../actions";


export function ResetErrorLink({ onClick, ...props }: LinkProps) {
    const dispatch = useAppDispatch();

    const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
        dispatch(errorActions.resetError());
        onClick?.(e);
    }
    return <Link {...props} onClick={handleClick} />
}